export default {
  useMoreAddress: 'Utiliser une autre adresse',
  hideAddress: "Plier l'adresse",
  productInventory: 'Liste des marchandises',
  tag: 'Étiquette',
  retainTag: 'Étiquette réservée',
  delTag: "Supprimer l'étiquette",
  externalPack: 'Emballage extérieur',
  packDetail: "Détails de l'emballage",
  postLine: 'Itinéraire de livraison',
  selectLine: "Sélectionner l'itinéraire",
  editLine: "Modifier l'itinéraire",
  service: 'Service',
  cancelServe: 'Annuler le service',
  previewPackage: 'Aperçu du colis',
  postCountry: "Pays d'envoi",
  packageNo: 'N° de colis',
  deliver: 'Livrer à',
  packageDetail: 'Détails du colis',
  addressInfo: "Informations sur l'adresse",
  voWeight: 'Poids volumétrique',
  firstWeight: 'Premier poids',
  continueWeight: 'Poids renouvelé',
  actWeight: 'Poids réel',
  packageStatus: 'Statut du colis',
  freightDetail: 'Informations sur les coûts',
  declareCurrency: 'Devise de déclaration',
  selfDeclare: 'Déclaration indépendante',
  packageDeclarePrice: 'Montant total de la déclaration du colis',
  youPackageProduct: 'Les marchandises dans votre colis',
  editYourDeclare: 'Veuillez modifier vos informations de déclaration',
  startDeclare: 'Commencer la déclaration',
  declareType: 'Type de déclaration',
  productNo: 'ID produit',
  declareProductPrice: 'Prix unitaire déclaré',
  declareTotalPrice: 'Montant total des marchandises déclarées',
  editDeclare: 'Modifier la déclaration',
  declareLinePriceHint:
    'Le montant total déclaré le plus bas pour la ligne actuelle : {min}, le plus élevé : {max}',
  classMaxNumHint: 'Le nombre de catégories uniques a atteint la limite supérieure {max}',
  addDeclareProduct: 'Ajouter des marchandises déclarées',
  plsConfirmInfo: 'Veuillez confirmer les informations',
  wipePackProduct: 'Marchandises non emballées',
  foldPackProduct: 'Marchandises pliables',
  wipeTagProduct: 'Marchandises sans étiquette',
  aboutCalcWeightExplain:
    "Comme le colis n'est pas emballé actuellement, nous ne connaissons pas le poids réel du colis à ce stade, nous ne pouvons donc nous fier qu'à plusieurs paramètres existants pour estimer le poids du colis, afin de percevoir l'acompte. Une fois le colis emballé et le poids réel obtenu, le trop-perçu et le moins-perçu seront remboursés.",
  expressInfo: 'Informations logistiques',
  deliveryMode: 'Mode de distribution',
  targetCountry: 'Pays de destination',
  cancelPackage: 'Annuler le colis',
  cancelPackageHint:
    "Confirmer l'annulation de ce colis ? Vous ne pourrez pas le récupérer après l'annulation.",
  isDelPackage: 'Confirmer la suppression définitive du colis ?',
  delPackageHint:
    'Après la suppression définitive, vous ne pourrez plus consulter le colis, veuillez faire preuve de prudence !',
  receivedTips: 'Votre colis a été reçu, bienvenue à nouveau',
  packageQuestion: 'Il y a un problème avec la livraison du colis, vous pouvez',
  afterSale: 'Demander un service après-vente',
  repair: 'Remboursement',
  ucan: 'Vous pouvez',
  clickAdd: 'Cliquez sur Ajouter',
  addCategoryTips: "Il n'y a pas de nom de produit que vous souhaitez déclarer",
  noCarrierLines: "Aucune route d'expédition n'est disponible",
  confirmPackageTitle: 'Avez-vous confirmé la réception des marchandises ?',
  confirmPackageTips:
    'Pour protéger vos droits après-vente, veuillez confirmer la réception après avoir vérifié que le colis est correct',
  receiptSuccess: 'Réception réussie',
  position: 'Position',
  time: 'Heure',
  duty: 'Numéro de TVA',
  inputTrueDuty: 'Veuillez saisir le numéro de TVA correct',
  serveStatusEnum: {
    1: 'Photos personnalisées',
    2: 'Prolonger la période de stockage',
    5: 'Vidéo personnalisée',
  },
  inputCareTime: 'Veuillez sélectionner la durée de stockage',
  holder: {
    noInputSearch: 'N° de colis/N° de produit',
    inputEditDeclareInfo: 'Veuillez modifier vos informations de déclaration',
    packageRemark:
      "Si vous avez d'autres exigences particulières pour le colis, veuillez les noter ici",
    yourPriceSummary: 'Votre récapitulatif des prix',
  },
  calcFee: 'Frais estimés',
  realFee: 'Frais réels',
  declare: {
    repeatDeclare: 'Type de déclaration en double',
    addDeclareType: 'Veuillez ajouter le type de déclaration',
  },
  feeEnum: {
    totalAmount: 'Acompte estimé',
    deposit: 'Coût estimé',
    overLongFee: 'Frais de dépassement de longueur',
    overWeightFee: "Frais d'excès de poids",
    remoteFee: 'Frais de zone éloignée',
    feeCustoms: 'Frais de manutention logistique',
    feeFuel: 'Surtaxe carburant',
    feeOperation: "Frais d'opération",
    feeService: 'Frais de service',
    valueAddedTax: 'Taxe sur la valeur ajoutée',
    insuranceService: "Prime d'assurance",
    incrementAmount: 'Frais de service à valeur ajoutée',
    lineDiscount: 'Remise de ligne',
    discount: 'Remises VIP',
    coupon: 'Sélectionner un coupon',
    passwordDiscount: 'Mot de passe préférentiel',
    orderPreDiscount: 'Remise sur la marchandise',
    insuranceDiscount: "Réduction d'assurance",
    incrementDiscount: 'Offre de service à valeur ajoutée',
    preVolumeCal: 'Pesée estimée',
    actDeposit: 'Fret après pesée',
    actDepositAmount: 'Paiement final',
  },
  ratePaymentEnum: {
    name: 'Mode de paiement de la taxe',
    0: 'Payé par le destinataire',
    1: 'TVA/TPS de la plateforme',
    2: 'TVA/TPS personnelle',
    3: 'IOSS de la plateforme',
    4: 'IOSS personnel',
    5: "TVA/TPS de l'entreprise",
    6: 'TVA/TPS des prestataires logistiques',
    7: 'IOSS des prestataires logistiques',
    8: 'Hors taxes',
  },
  bagStatusEnum: {
    0: 'Colis normal',
    1: 'Retour national',
    2: 'Retour international',
    3: 'Annulé',
    4: 'Rechargement en attente',
  },
  packageStatusEnum: {
    0: 'En attente de traitement',
    1: 'En cours de traitement',
    2: 'Collecte en cours',
    3: 'Collecté',
    4: 'Emballage terminé',
    5: 'Pesé',
    6: 'Lettre de transport imprimée',
    7: 'Scanné',
    8: 'Livré au transporteur',
    9: 'Expédié',
    20: 'Reçu',
  },
  declareEnum: {
    name: 'Méthode de déclaration',
    0: 'Déclaration système',
    1: 'Déclaration personnelle',
  },
  backText: 'Retour',
  packageInformation: 'Informations sur le colis',
  parcelNumber: 'N° de colis',
  noValidRule: 'Le montant déclaré ne respecte pas les règles : {rule}',
  shippingAgree: "Accord d'expédition de colis acbuy",
  haveDiscountCode: "J'ai un code de réduction",
  inputDiscountCode: 'Saisissez votre code de réduction ici',
  expressNo: 'Numéro de suivi',
  shipping: 'Expédition',
  taxation: 'Taxation',
  acCare: 'Ac Care',
  discountCode: 'Code de réduction',
  coupon: 'Coupon',
  rangeDeclare: 'Votre montant total déclaré dépasse la limite',
  noCouponData: "Aucun coupon ne correspond aux conditions de réduction d'expédition.",
  exchange: 'Échange',
  'i18n-000001': 'Matériau',
  'i18n-000002': 'Couleur',
  'i18n-000003': 'Modèle/Taille',
  'i18n-000004': 'Matériau',
  'i18n-000005': 'Déclarer ou non',
  'i18n-000006': 'Rappel amical',
  'i18n-000007':
    "Une fois soumise, Acbuy ne modifiera pas les informations de déclaration. En cas d'échec du pré-dédouanement, nous procéderons quand même à l'expédition.",
  'i18n-000008':
    '1. Conformément aux exigences des douanes brésiliennes, veuillez déclarer en détail le nom, le matériau, la couleur, le modèle/la taille, et le nom total de la déclaration ne doit pas dépasser 5 ;',
  'i18n-000009':
    '2. Étant donné que les petits colis en provenance du Brésil sont destinés à un usage personnel, plusieurs colis arrivant simultanément aux douanes seront retenus. Veuillez récupérer les articles multiples séparément ;',
  'i18n-000010':
    "3. Il est recommandé qu'un seul colis ne dépasse pas 4 kg, et chaque marchandise doit être déclarée à au moins 3 USD. Pour les produits de grande valeur (consoles de jeux, téléphones portables, tablettes, ordinateurs, etc.), déclarez-les honnêtement pour éviter la saisie douanière ;",
  'i18n-000011':
    "4. Norme fiscale locale au Brésil : 17 % d'ICMS + 20 % de droits de douane sont appliqués pour la déclaration de moins de 50 $, et 17 % d'ICMS + 60 % de droits de douane sont appliqués pour la déclaration de plus de 50 $.",
  'i18n-000012':
    "5. Veuillez prêter attention aux SMS et aux e-mails après l'arrivée du colis au Brésil et payer les taxes à temps",
  'i18n-000013': '{num} articles',
  'i18n-000014': 'Nom du produit',
  cartonWarning:
    "Votre colis est trop grand en taille ou en poids. Nous vous suggérons d'utiliser une boîte en carton pour obtenir une meilleure compression et réduire le risque de dommages pendant l'expédition",
  'i18n-0000003': 'Numéro de colis',
  'i18n-0000004': 'Heure de soumission',
  'i18n-0000005': 'Volume estimé',
  'i18n-0000006': 'Poids estimé',
  'i18n-0000007': 'Coût estimé',
  'i18n-0000009': "Méthode d'expédition",
  'i18n-0000010': 'Numéro de suivi',
  'i18n-0000011': 'En attente de paiement',
  'i18n-0000017': 'Réduction de coupon',
  'i18n-0000018': 'Adresse de livraison',
  'i18n-0000019': 'Informations de déclaration',
  'i18n-0000020': 'Nom de la déclaration du produit',
  'i18n-0000021': 'Montant déclaré ($)',
  'i18n-0000022': 'Quantité',
  'i18n-0000023': 'Sous-total ($)',
  'i18n-0000024': 'Montant total déclaré',
  'i18n-0000025': 'Informations sur le produit',
  'i18n-0000026': 'Produit',
  'i18n-0000027': 'Poids (g)',
  'i18n-0000028': 'Volume (cm³)',
  'i18n-0000029': "Détails de l'emballage",
  'i18n-0000033': 'Remboursement en attente',
  'i18n-0000034': 'En attente de paiement supplémentaire',
  'i18n-0000035': 'Volume réel',
  'i18n-0000036': 'Poids facturé',
  'i18n-0000037': 'Coût réel',
  'i18n-0000038': 'Paiement réel',
  'i18n-0000039': 'Photos du colis',
  'i18n-0000040': 'Télécharger la facture du colis',
  'i18n-0000041': 'Remboursé au solde du portefeuille',
  'i18n-0000042': 'Remb.',
  'i18n-0000043': 'Paiement supplémentaire effectué',
  'i18n-0000046': 'Développer',
  'i18n-0000047': 'Réduire',
  'i18n-0000048': 'Suivi logistique',
  'i18n-0000049': 'Informations de pesée',
  'i18n-0000050': 'Remboursé',
  'i18n-0000051': 'Attendu dans le portefeuille dans les 72 heures',
  samePreviewTips: 'Ce colis d’essai a déjà été soumis. Voulez-vous le soumettre à nouveau ?',
  confirmSubmitTitle: 'Confirmer et continuer',
  confirmSubmitText: 'Veuillez confirmer votre adresse de livraison:',
  confirmSubmitContent: `Adresse de livraison : {address}

Avis important : Le poids facturable affiché est une estimation. Le poids final sera déterminé après l’emballage, en fonction du poids réel mesuré ou du poids volumétrique, selon la valeur la plus élevée. En cas de différence entre les frais estimés et finaux, un ajustement sera effectué selon le principe du “remboursement ou supplément”.`,
}
